/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_Entityfilter1Inputs */

const en_tab_entityfilter1 = /** @type {(inputs: Tab_Entityfilter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity Filter`)
};

const de_tab_entityfilter1 = /** @type {(inputs: Tab_Entityfilter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitätenfilter`)
};

/**
* | output |
* | --- |
* | "Entity Filter" |
*
* @param {Tab_Entityfilter1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const tab_entityfilter1 = /** @type {((inputs?: Tab_Entityfilter1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_Entityfilter1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tab_entityfilter1(inputs)
	return de_tab_entityfilter1(inputs)
});
export { tab_entityfilter1 as "tab_entityFilter" }